module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "xilografia inner-screen"
  }, [_c('video-page', {
    attrs: {
      "data": _vm.data
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3106345e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Xilografia.vue
// module id = 563
// module chunks = 1